import src from "IMAGE";
export default { src, width: 643, height: 668, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
